import { REHYDRATE } from 'redux-persist';
import { GetCategory } from './action';

var initState = {
    setToken: '',
    getPartnerDetails: {},
    getLoginRole: {},
    getLoginAdminByID: '',
    storePartnerEvent: {},
    getSatelliteScreenDetails: {},
    storeSatelliteScreenEvent: {},
    profileName: '',
    getLoginUser: {},
    Searchvalue:'',
    getBackToAdminFlag: false,
    currentTab: '',
    HighlightList: '',
    HighlightEditId: '',
    PrivateEventList: '',
    PrivateEventId: '',
    getBackToAdminPreviousPath: '',
    scannerLoginData: {},
    MemberShipEditListId: '',
    PostAcceptanceEditListId: '',
    titleProjectInfoget: '',
    locationEditId: '',
    FpgLockeded: false,
    countries: [],
    pageTakeoverEditId: '',
    accessControlEditId: '',
    recordViewers: [],
    recordConflict: null,
};

function sundanceReducer(state = initState, action) {
    switch (action.type) {
        
        case 'CurrentTab':
            return {
                ...state,
                currentTab: action.res
            };
        case 'CurrentShortTab':
            return {
                ...state,
                currentShortTab: action.res
            };
            case 'Searchvalue':
                
                return {
                    ...state,
                    Searchvalue: action.res
                };
                case 'searchLocation':
                
                    return {
                        ...state,
                        searchLocation: action.res
                    };
        // case 'ClearTab':
        //     return {
        //         ...state,
        //         currentTab: ''
        //     };
        case 'LoginToken':
            return {
                ...state,
                setToken: action.res
            };
        case 'LoginRole':
            return {
                ...state,
                getLoginRole: action.res
            };
        case 'LoginAdminByID':
            return {
                ...state,
                getLoginAdminByID: action.res
            }
        case 'GetPartner':
            return {
                ...state,
                getPartnerDetails: action.res
            };
        case 'GetPartnerEvent':
            return {
                ...state,
                storePartnerEvent: action.res
            };
        case 'GetSatelliteScreen':
            return {
                ...state,
                getSatelliteScreenDetails: action.res
            };
        case 'GetGetSatelliteScreenEvent':
            return {
                ...state,
                storeSatelliteScreenEvent: action.res
            };
        case 'ProfileName':
            return {
                ...state,
                profileName: action.res
            };
        case 'LoginUser':
            return {
                ...state,
                getLoginUser: action.res
            };
        case 'BackToAdminFlag':
            return {
                ...state,
                getBackToAdminFlag: action.res
            };
        case 'BackToAdminPreviousPath':
            return {
                ...state,
                getBackToAdminPreviousPath: action.res
            };
        case 'ProductEditList':
            return {
                ...state,
                ProductEditListEditId: action.res
            }
        case 'EmailEditList':
            return {
                ...state,
                EmailListEditId: action.res
            }
        case 'StoreProductEditList':
            // console.log(action.res,"reddddd");
            return {
                ...state,
                StoreProductEditList: action?.res?._id,
                StoreProductEditVarientId: action?.res?.variants?._id
            }
        case 'MemberShipEditList':
            return {
                ...state,
                MemberShipEditListId: action.res
            }
        case 'CouponEditList':
            return {
                ...state,
                CouponEditListEditId: action.res
            }
        case 'PostAcceptanceEditList':
            return {
                ...state,
                PostAcceptanceEditListId: action.res
            }
        case 'titleProjectInfo':
            return {
                titleProjectInfoget: action.res
            }
        case 'filmEditData':
            return {
                ...state,
                filmEditId: action.res
            };
        case 'TalkEventEditData':
            return {
                ...state,
                TalkEventEditDataEditId: action.res
            };
        case 'NewFrontierEditData':
            return {
                ...state,
                NewFrontierEditDataEditId: action.res
            };
        case 'PartnerEventsEditData':
            return {
                ...state,
                partnerEventId: action.res
            };
        case 'OtherEventsEditData':
            return {
                ...state,
                otherEventId: action.res
            };
        case 'LiveSceeringEditData':
            return {
                ...state,
                LiveSceeringEditId: action.res
            };
        case 'ShortProgramEditData':
            return {
                ...state,
                shortProgramId: action.res
            };
        case 'EpisodicShortProgramEditData':
            return {
                ...state,
                episodicShortProgramId: action.res
            };
        case 'NotificationEditData':
            return {
                ...state,
                notificationId: action.res
            }; 
        case 'ScannerLoginData':
            return {
                ...state,
                scannerLoginData: action.res
            };
        case 'Countries':
            return {
                ...state,
                countries: action.res
            };
        case 'PageTakeoverEditData':
            return {
                ...state,
                pageTakeoverEditId: action.res
            };
        case REHYDRATE:
            return {
                ...state,
                getPartnerDetails: action.payload &&
                    action.payload.getPartnerDetails ? action.payload.getPartnerDetails : {},
                getLoginRole: action.payload &&
                    action.payload.getLoginRole ? action.payload.getLoginRole : {},
                getLoginAdminByID: action.payload &&
                    action.payload.getLoginAdminByID ? action.payload.getLoginAdminByID : "",
                storePartnerEvent: action.payload &&
                    action.payload.storePartnerEvent ? action.payload.storePartnerEvent : "",
                profileName: action.payload &&
                    action.payload.profileName ? action.payload.profileName : "",
                getLoginUser: action.payload &&
                    action.payload.getLoginUser ? action.payload.getLoginUser : {},
                getBackToAdminFlag: action.payload &&
                    action.payload.getBackToAdminFlag ? action.payload.getBackToAdminFlag : false,
                scannerLoginData: action.payload &&
                action.payload.scannerLoginData ? action.payload.scannerLoginData : {},
                countries: action.payload &&
                    action.payload.countries ? action.payload.countries : [],

                FpgLockeded: action.payload && action.payload.FpgLockeded ? action.payload.FpgLockeded : false,
                pageTakeoverEditId: action.payload &&
                    action.payload.pageTakeoverEditId ? action.payload.pageTakeoverEditId : '',
                accessControlEditId: (action.payload && action.payload.accessControlEditId) ? action.payload.accessControlEditId : ''
            }
        case 'HighlightTable':
            return {
                ...state,
                HighlightList: action.payload
            };
        case 'HighlightEdit':
            return {
                ...state,
                HighlightEditId: action.payload
            };
        case 'PrivateEventTable':
            return {
                ...state,
                PrivateEventList: action.payload
            };
        case 'PrivateEventEdit':
            return {
                ...state,
                PrivateEventId: action.payload
            };
        case 'locationEditData':
            return {
                ...state,
                locationEditId: action.res
            };
        case 'FpgLocked':
            return {
                ...state,
                FpgLockeded: action.res
            }
        case 'AccessControlEditData':
            return { ...state, accessControlEditId: action.res };
        case 'SetRecordViewers':
            return {
                ...state,
                recordViewers: action.res
            };
        case 'SetRecordConflict':
            return {
                ...state,
                recordConflict: action.res
            };
        case 'ClearRecordPresence':
            return {
                ...state,
                recordViewers: [],
                recordConflict: null
            };
        default:
            return {
                ...state
            }
    }

}

export const reducer = sundanceReducer;